module.exports = __webpack_public_path__ + "6e6dfc4d1ea51d285a9da2484e11de12.pdf";